// Packages
import { defineStore } from 'pinia';
import type { IPayloadCMSSupportArticles, IPayloadCmsSupportSections } from '~/server/api/support/[region]/types';

// Utils
export const useSupportSectionsStore = defineStore('support', () => {
  const sections = ref<IPayloadCmsSupportSections>({ docs: [] });
  const article = ref<IPayloadCMSSupportArticles["docs"][number] | undefined>(undefined);

  function setSections(new_sections: IPayloadCmsSupportSections) {
    sections.value = new_sections
  }

  function setArticle(new_article: IPayloadCMSSupportArticles["docs"][number]) {
    article.value = new_article
  }

  function reset() {
    sections.value = { docs: [] };
  }

  return {
    sections,
    setSections,
    article,
    setArticle,
    reset
  }
});
